import React, { useState, useEffect, useMemo } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import axios from 'axios';
import { es } from 'date-fns/locale';

import socket from '../tools/socke';

const CalendarioFiltrado = ({ onSeleccionarFecha }) => {
  const [feriados, setFeriados] = useState([]);
  const [fechaSeleccionada, setFechaSeleccionada] = useState(null);
  const hoy = new Date();

  const devuelveFeriados = async () => {
    try {
      const client = axios.create({
        baseURL: "https://wwwa.isepsantafe.net.ar/expedientes/devuelveFeriados"
      });
      const response = await client.post('/');
      if (response.data?.feriado) {
        setFeriados(response.data.feriado);
      }
    } catch (error) {
      console.error("Error al obtener los feriados:", error);
    }
  };

  useEffect(() => {
    devuelveFeriados();

    socket.on("nuevoFeriado", () => {
//       console.log("Nuevo feriado recibido por socket");
      devuelveFeriados();
    });

    return () => {
      socket.off("nuevoFeriado");
    };
  }, []);

  const fechasValidas = useMemo(() => {
    return feriados.map(item => {
      const [anio, mes, dia] = item.fecha.split('-').map(Number);
      return new Date(anio, mes - 1, dia);
    });
  }, [feriados]);

  const claseDia = (fecha) => {
    const esValida = fechasValidas.some(f => f.toDateString() === fecha.toDateString());
    if (esValida) return 'highlighted-day';
    return undefined;
  };

  const handleChange = (date) => {
    setFechaSeleccionada(date);
    onSeleccionarFecha?.(date);
  };

  return (
    <div style={{ textAlign: 'center', marginTop: '2rem' }}>
      <h3>Días Feriados</h3>
      <DatePicker
        locale={es}
        selected={fechaSeleccionada}
        onChange={handleChange}
        dayClassName={claseDia}
        highlightDates={fechasValidas}
        placeholderText="Elegí una fecha"
        dateFormat="dd 'de' MMMM 'de' yyyy"
        inline
      />
    </div>
  );
};

export default CalendarioFiltrado;
